function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 10C17.319 10 15.042 7.185 14.202 6C15.042 4.815 17.319 2 20 2C22.206 2 24 3.794 24 6C24 8.206 22.206 10 20 10ZM6 10C3.794 10 2 8.206 2 6C2 3.794 3.794 2 6 2C8.681 2 10.958 4.815 11.798 6C10.958 7.185 8.681 10 6 10ZM20 0C16.796 0 14.256 2.645 13 4.264C11.744 2.645 9.204 0 6 0C2.691 0 0 2.691 0 6C0 9.309 2.691 12 6 12C9.204 12 11.744 9.355 13 7.736C14.256 9.355 16.796 12 20 12C23.309 12 26 9.309 26 6C26 2.691 23.309 0 20 0Z"
});

function SvgIcInfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfinity);
export default ForwardRef;